import { DOCTOR_APIS } from "../utils/constants";
import { IDoctorsState, IDoctorsFetchApiResponse } from "../interfaces/IDoctor";
import Axios from "../utils/axiosInterceptor"; // Adjust the import path as necessary

export const fetchDoctors = async (
  search: string,
  hospitalId: number | string | undefined
): Promise<IDoctorsFetchApiResponse> => {
  try {
    const response = await Axios.get<Array<IDoctorsState>>(`${DOCTOR_APIS.ALL_DOCTORS}/${hospitalId}/health_care_doctors/search/${search}`);

    if (response.status === 200) {
      return { availableDoctor: response.data || [], status: response.status, loading: false };
    } else {
      throw new Error(`Error: ${response.statusText}`);
    }
  } catch (error) {
    return { availableDoctor: [], status: 500, loading: false };
  }
};
